<template>
  <div class="w-full flex flex-col">
    <div class="m-2 p-8 bg-white rounded shadow max-w-3xl space-y-6" v-if="course">
      <div class="no-print">
        <router-link class="text-sm text-primary underline" to="/Matrices/Courses">Courses</router-link>
      </div>
      <div class="border border-gray-300 p-8 space-y-4">
        <p class="text-sm uppercase tracking-wide text-gray-500">Completion record</p>
        <h1 class="text-2xl font-medium text-primary">{{ course.Title }}</h1>
        <p>{{ learner }}</p>
        <p v-if="progress.CompletedAt">Completed {{ progress.CompletedAt }}</p>
        <p v-if="progress.Score != null">Score {{ progress.Score }}%</p>
        <p class="text-sm text-gray-600">This completion is recorded on the staff training record.</p>
      </div>
      <button class="no-print px-4 py-2 bg-primary text-white rounded" type="button" @click="print">Print</button>
    </div>
    <p class="m-4 text-sm text-gray-600" v-else-if="loaded">No completion record is available for this course.</p>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { auth, db } from "../../../db.js";

const route = useRoute();
const store = useStore();
const loaded = ref(false);
const progress = reactive({ CompletedAt: "", Score: null, RecordID: "" });

const course = computed(() => {
  const id = route.params.id;
  const record = store.state["Home/Courses"]?.[id];
  return record ? { ...record, ID: record.ID || id } : null;
});
const learner = computed(() => store.getters.userName || "Learner");

function userId() {
  return store.getters.userID && store.getters.userID !== "Unknown"
    ? store.getters.userID
    : auth.currentUser?.uid || "";
}

function print() {
  window.print();
}

onMounted(async () => {
  await db.watch("Home/Courses", store);
  const uid = userId();
  if (uid && route.params.id) {
    const snapshot = await db.ref(`Userdata/${uid}/Training/CourseProgress/${route.params.id}`).once("value");
    const saved = snapshot.val();
    if (saved) Object.assign(progress, saved);
  }
  loaded.value = true;
});
</script>

<style scoped>
@media print {
  .no-print { display: none; }
}
</style>
